import {useDispatch, useSelector} from "react-redux";
import React, {useEffect, useState} from 'react';
import {Button, Dropdown} from "react-bootstrap";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {TYPE_SHIPMENT} from "../../../../enum/ExcelTemplateTypes";
import {excelFileUploader} from "../../../../helpers/excel-uploader";
import {faFileExcel, faSpinner} from "@fortawesome/free-solid-svg-icons";
import {selectLang, Translate} from "../../../../app/store/reducers/main/mainReducer";
import {selectOrganizationTemplates} from "../../../../app/store/reducers/excel/excelReducer";
import {uploadShipmentToExcelAsync} from "../../../../app/store/reducers/shipment/shipmentReducer";
import checkPermission from "../../../../enum/Permission/CheckPermission";
import toastPermission from "../../../../enum/Permission/ToastPermission";
import {PermissionEdiShipmentDownloadExcel} from "../../../../enum/Permission/EdiPermission";

const UploadShipmentToExcel = ({id, number, ...props}) => {
    const dispatch = useDispatch()
    const [shipmentTypeTemplates, setShipmentTypeTemplates] = useState([]);
    const organizationTemplates = useSelector(selectOrganizationTemplates);
    const [loading, setLoading] = useState(false);
    const lang = useSelector(selectLang);
    const t = Translate;

    useEffect(() => {
        const templates = organizationTemplates.filter(template => template.type === TYPE_SHIPMENT) || [];
        setShipmentTypeTemplates(templates);
    }, [organizationTemplates])

    const uploadShipment = (uri) => {
        if(dispatch(checkPermission(PermissionEdiShipmentDownloadExcel))) {
            setLoading(true);

            uploadShipmentToExcelAsync({uri: uri, id: id})
                .then(loadedContent => {
                    excelFileUploader({
                        content: loadedContent,
                        fileName: t(lang, 'edi.shipment.excel.file.name', {number: number}),
                    })
                })
                .catch(error => console.log(error))
                .finally(() => setLoading(false))
        }
        else dispatch(toastPermission())
    };

    return (
        <>
            {shipmentTypeTemplates.length > 1
                ?
                <Dropdown {...props}>
                    <Dropdown.Toggle bsPrefix="toggle" variant="falcon-default" size="sm" disabled={loading}>
                        {loading
                            ? <FontAwesomeIcon className="me-1" pulse={true} icon={faSpinner}/>
                            : <FontAwesomeIcon className="me-1" icon={faFileExcel}/>
                        }
                        <span className="d-none d-sm-inline-block">
                        {t(lang, 'edi.common.export_to_excel')}
                    </span>
                    </Dropdown.Toggle>
                    <Dropdown.Menu className='py-2'>
                        {shipmentTypeTemplates.map((template, index) => (
                            <Dropdown.Item key={index} onClick={() => uploadShipment(template.uri)}>
                                {t(lang, 'main.common.file.upload.template_name.prefix', {template_name: t(lang, `common.excel.template.name.${template.name}`)})}
                            </Dropdown.Item>
                        ))}
                    </Dropdown.Menu>
                </Dropdown>
                :
                <Button {...props} variant="falcon-default" size="sm" onClick={() => {
                    const [defaultTemplate] = shipmentTypeTemplates;
                    uploadShipment(defaultTemplate.uri);
                }}>
                    {loading
                        ? <FontAwesomeIcon className="me-1" pulse={true} icon={faSpinner}/>
                        : <FontAwesomeIcon className="me-1" icon={faFileExcel}/>
                    }

                    <span className="d-none d-sm-inline-block">{t(lang, 'edi.common.export_to_excel')}</span>
                </Button>
            }
        </>
    );
};

export default UploadShipmentToExcel;
